import { BuchungBestellart } from "@/entities/common/enums"
import BPBuchungBestellartRequest from "@/entities/common/pending/bp_buchung_bestellart_request"
import RemoteResult from "@/entities/common/remote_result"
import router from "@/router"
import store from "@/store"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"
import MainLogic from "../main_logic"

export default class SofortSelectLogic extends BaseLogic {
  serviceAngefordertCompleted: boolean = false
  serviceAngefordertWorking: boolean = false
  serviceAngefordertError: boolean = false

  zurueckZurBestellung() {
    // router.push({
    //   name: RouteNames.BESTELLUNG.DETAILS,
    //   params: { id: this.mainLogic.bestellungPending.id },
    // })
  }

  serviceRufen() {
    var request = new BPBuchungBestellartRequest()
    request.id = store.state.user.identifier
    request.bestellart = BuchungBestellart.SERVICE

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungpendingSofortBestellart,
      request
    ).then((response) => {})

    // this.serviceAngefordertWorking = true
    // var nbd = store.state.bestellungPending

    // var request = new BuchungsartInsertRequest()
    // request.id = nbd.id
    // request.bestellart = BuchungBestellart.SERVICE

    // Poster.postUser<RemoteResult<DateTimeCapsule>>(
    //   RestPaths.bestellungKundeTischBuchungsartWaehlen,
    //   request
    // ).then((response) => {
    //   this.serviceAngefordertWorking = false
    //   if (response.data.success) {
    //     this.serviceAngefordertCompleted = true
    //   }
    // })
  }

  selbstBestellen() {
    var request = new BPBuchungBestellartRequest()
    request.id = store.state.user.identifier
    // request.id = this.mainLogic.bestellungPending.id
    request.bestellart = BuchungBestellart.SELBST

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungpendingSofortBestellart,
      request
    ).then((response) => {
      if (response.data.success) {
        router.push({ name: RouteNames.NEU.SHOPPING.PRODUKTE })
      }
    })

    // var nbd = store.state.bestellungPending
    // var request = new BuchungsartInsertRequest()
    // request.id = nbd.id
    // request.bestellart = BuchungBestellart.SELBST

    // Poster.postUser<RemoteResult<DateTimeCapsule>>(
    //   RestPaths.bestellungKundeTischBuchungsartWaehlen,
    //   request
    // ).then((response) => {
    //   if (response.data.success) {
    //     router.push({ name: RouteNames.FILIALE_PAGE_AREA.SHOPPING.PRODUKTE })
    //   }
    // })
  }
}
